import { getType, vCompare } from '@douban/rexxar-common/es/assets/js/utils';

export function extractVersionFrom(name: string, ua = navigator.userAgent) {
  const reg = new RegExp(`${name}( |/)([0-9.]*)`, 'i');
  const info = ua.toLowerCase().match(reg);
  const version = info ? info.pop()?.split('.').slice(0, 3).join('.') : '';
  return version;
}


export const FRODO_UA_PATTERN = 'com\\.douban\\.frodo(\\.(?:test|hap))?';

export function getFrodoVersion(ua = navigator.userAgent) {
  return extractVersionFrom(FRODO_UA_PATTERN, ua);
}

const FRODO_VERSION = getFrodoVersion();

// v == cur
const versionIs = (v: string, cur: string) => {
  if (getType(v) !== 'String') {
    throw new Error('Version value expected a string');
  }
  return vCompare(v, cur || '999') === 0;
};

// v <= cur
const versionSince = (v: string, cur: string) => {
  if (getType(v) !== 'String') {
    throw new Error('Version value expected a string');
  }
  return vCompare(v, cur || '999') !== 1;
};

export interface Version {
  __str__: string;
  getStr(): string;
  is(v: string): boolean;
  since(v: string): boolean;
}


export const frdVersion: Version = {
  getStr: FRODO_VERSION,
  is: FRODO_VERSION ? (v: string) => versionIs(v, FRODO_VERSION) : undefined,
  since: FRODO_VERSION ? (v: string) => versionSince(v, FRODO_VERSION) : undefined
} as any;



